/*
 * Copyright (c) 2023. Legalbird eine Marke der R+S Internet Jewels GmbH
 */

import FineCalculator from "../../FineCalculator/FineCalculator";
import PageContentContainer from "../../Container/PageContentContainer";
import PageHeadline from "../../PageHeadline/PageHeadline";
import ContentBox from "../../ContentBox/ContentBox";

export default function FineCalculatorPage() {
  return (
    <PageContentContainer size={"tiny"}>
      <PageHeadline main="Bußgeld berechnen" />
      <ContentBox>
        <FineCalculator />
      </ContentBox>
    </PageContentContainer>
  );
}
